import React from 'react';

import { Form } from '@dashboard/components/Formik';
import Link from '@dashboard/components/Link';
import usePage from '@dashboard/hooks/usePage';

const FormTitleForm = () => {
  const { page, updatePage } = usePage();

  return (
    <div>
      <Form
        initialValues={{
          title: page.title || '',
        }}
        fields={[
          {
            name: 'title',
            type: 'text',
            label: 'Form title',
            optional: true,
            placeholder: 'Form title',
            helpText: (
              <Link
                to={`/pages/${page._id}/customize/settings/url-slug`}
                className="!font-normal !text-gray-500 dark:!text-muted-foreground underline hover:text-gray-700 dark:hover:text-muted-foreground"
              >
                <span>/{page.slug}</span>
              </Link>
            ),
          },
        ]}
        autosave
        autosaveDebounceMs={500}
        showState={false}
        onSubmit={async values => {
          const { data, error } = await updatePage.mutateAsync(values);

          return {
            data,
            error,
          };
        }}
      />
    </div>
  );
};

export default FormTitleForm;
